import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { AuthService } from 'src/app/auth/auth.service';
declare var $: any;

@Component({
    selector: 'app-create-send-contract',
    templateUrl: './create-send-contract.component.html',
    styleUrls: ['../summary.component.css', './create-send-contract.component.css']
})
export class CreateSendContractComponent implements OnInit {

    @Input() statesOfIncorporation: any[] = [];
    @Input() appId: any = 0;
    @Input() defaultOfferId: any = 0;
    @Input() maxApprovedAmount: any = 0;

    @Output() reloadSlice = new EventEmitter<void>();

    sendDocsForm: FormGroup;
    invoiceAddressForm: FormGroup;

    sendDocsFormSubmitted = false;
    invoiceAddressFormSubmitted = false;

    numberOfAttempts = 0;
    numberOfDocsExceeded = false;

    messageTitle = '';
    messageMessageA = '';
    messageMessageB = '';
    messageMessageC = '';
    messageMessageAClass = '';
    messageMessageBClass = '';
    messageMessageCClass = '';
    dialogClass = '';

    modalIdE = 'InvoiceError' + this.appId;
    attempModalId = 'attempModal' + this.appId;
    modalId = 'summarySendDocsAddress' + this.appId;
    sendContractsSuccessId = 'sendContractsSuccess' + this.appId;

    defaultLeaseeAddress = {
        streetAddress: '',
        city: '',
        county: '',
        state: '',
        unit: '',
        zipCode: ''
    };

    invoiceAddresArrays = {
        cities: [],
        states: [],
        counties: []
    };

    constructor(
        private authService: AuthService,
        private connectionService: ConnectionService,
        private formBuilder: FormBuilder
    ) {
        this.sendDocsForm = this.formBuilder.group({
            invoiceNumber: ['', Validators.required],
            subTotal: ['', Validators.required, this.requestedAmount.bind(this)]
        });

        this.invoiceAddressForm = this.formBuilder.group({
            sameAddres: ['true', Validators.required],
            address: [{ value: '', disabled: true }, Validators.required],
            unit: [{ value: '', disabled: true }],
            zip: [{ value: '', disabled: true }, Validators.required],
            city: [{ value: '', disabled: true }, Validators.required],
            state: [{ value: '', disabled: true }, Validators.required],
            county: [{ value: '', disabled: true }, Validators.required]
        });
    }

    ngOnInit() {
        this.modalIdE = 'InvoiceError' + this.appId;
        this.attempModalId = 'attempModal' + this.appId;
        this.modalId = 'summarySendDocsAddress' + this.appId;
        this.sendContractsSuccessId = 'sendContractsSuccess' + this.appId;
    }

    onSendDocsToCustomerSubmit() {
        this.sendDocsFormSubmitted = true;
        if (this.sendDocsForm.invalid) {
            return;
        }
        this.offerInvoiceRecalc().then(
            () => this.getApplication(this.appId).then(
                () => this.getInvoice(this.appId).then(
                    () => $('#summarySendDocsAddress' + this.appId).modal()
                )
            )
        );
    }

    getInvoice(applicationId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'equipment/' + applicationId, 'application/json').subscribe(
                (data: any) => {
                    if (data.object) {
                        data.object.forEach((invoiceItem: any) => {
                            this.invoiceAddressForm.controls.sameAddres.setValue(invoiceItem.lesseeAddress ? 'true' : 'false');
                            this.invoiceAddressForm.controls.address.setValue(invoiceItem.streetAddress);
                            this.invoiceAddressForm.controls.unit.setValue(invoiceItem.unit);
                            this.invoiceAddressForm.controls.zip.setValue(invoiceItem.zipCode);
                            this.invoiceAddressForm.controls.city.setValue(String(invoiceItem.city).toUpperCase());
                            this.invoiceAddressForm.controls.state.setValue(invoiceItem.state);
                            this.invoiceAddressForm.controls.county.setValue(String(invoiceItem.county).toUpperCase());
                            this.changeSameAddress();
                        });
                        if (data.object.length < 1) {
                            this.invoiceAddressForm.controls.sameAddres.setValue('true');
                            this.changeSameAddress();
                        }
                    }
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
    }

    getInvoiceData(selectedOfferId: number) {
        return {
            equipmentList: [
                {
                    city: this.invoiceAddressForm.controls.city.value,
                    condition: 'true',
                    cost: this.sendDocsForm.controls.subTotal.value,
                    county: this.invoiceAddressForm.controls.county.value,
                    description: '',
                    lesseeAddress: this.invoiceAddressForm.controls.sameAddres.value === 'true',
                    make: 'See invoice: ' + this.sendDocsForm.controls.invoiceNumber.value,
                    model: 'See invoice: ' + this.sendDocsForm.controls.invoiceNumber.value,
                    serialNumber: '',
                    state: this.invoiceAddressForm.controls.state.value,
                    streetAddress: this.invoiceAddressForm.controls.address.value,
                    supplier: '',
                    unit: this.invoiceAddressForm.controls.unit.value,
                    year: new Date().getFullYear(),
                    zipCode: this.invoiceAddressForm.controls.zip.value
                }
            ],
            offerId: selectedOfferId
        };
    }

    changeSameAddress() {
        if (this.invoiceAddressForm.controls.sameAddres.value == 'true') {
            this.invoiceAddressForm.controls.address.setValue(this.defaultLeaseeAddress.streetAddress);
            this.invoiceAddressForm.controls.unit.setValue(this.defaultLeaseeAddress.unit);
            this.invoiceAddressForm.controls.zip.setValue(this.defaultLeaseeAddress.zipCode);
            this.invoiceAddressForm.controls.city.setValue(String(this.defaultLeaseeAddress.city).toUpperCase());
            this.invoiceAddressForm.controls.state.setValue(this.defaultLeaseeAddress.state);
            this.invoiceAddressForm.controls.county.setValue(String(this.defaultLeaseeAddress.county).toUpperCase());
            this.invoiceAddressForm.controls.address.disable();
            this.invoiceAddressForm.controls.unit.disable();
            this.invoiceAddressForm.controls.zip.disable();
            this.invoiceAddressForm.controls.city.disable();
            this.invoiceAddressForm.controls.county.disable();
            this.onZipCodeKeyUp(
                this.defaultLeaseeAddress.state,
                String(this.defaultLeaseeAddress.city).toUpperCase(),
                String(this.defaultLeaseeAddress.county).toUpperCase()
            );
        } else {
            this.invoiceAddressForm.controls.address.enable();
            this.invoiceAddressForm.controls.unit.enable();
            this.invoiceAddressForm.controls.zip.enable();
            this.invoiceAddressForm.controls.city.enable();
            this.invoiceAddressForm.controls.county.enable();
            this.onZipCodeKeyUp();
        }
    }

    onZipCodeKeyUp(state?: any, city?: any, county?: any) {
        this.getZipCodeData(this.invoiceAddressForm.controls.zip.value).then(
            (data: any) => {
                if (data.object) {
                    this.invoiceAddresArrays.cities = data.object.city;
                    this.invoiceAddresArrays.states = this.statesOfIncorporation;
                    this.invoiceAddresArrays.counties = data.object.county;
                    this.invoiceAddressForm.controls.state.setValue(state ? state : data.object.state);
                    if (data.object.city.length > 0) this.invoiceAddressForm.controls.city.setValue(city ? city : data.object.city[0]);
                    if (data.object.county.length > 0) this.invoiceAddressForm.controls.county.setValue(county ? county : data.object.county[0]);
                } else {
                    this.invoiceAddresArrays.cities = [];
                    this.invoiceAddresArrays.counties = [];
                }
            },
            (error: any) => {
                this.invoiceAddresArrays.cities = [];
                this.invoiceAddresArrays.counties = [];
            }
        );
    }

    getInvoiceAddress() {
        return [{
            city: this.invoiceAddressForm.controls.city.value,
            county: this.invoiceAddressForm.controls.county.value,
            state: this.invoiceAddressForm.controls.state.value,
            zipCode: this.invoiceAddressForm.controls.zip.value
        }];
    }

    getZipCodeData(zipCode: string) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'application/zipData/' + zipCode, 'application/json').subscribe(
                (data: any) => {
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    }

    offerInvoiceRecalc() {
        return new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'application/' + this.defaultOfferId + '/offerInvoiceRecalc/' + this.authService.getUserId(),
                { newRequestAmount: this.sendDocsForm.controls.subTotal.value }, 'application/json',
                'sp_id=' + this.authService.getSalesPersonId()).subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        resolve(error);
                    }
                );
        });
    }

    getApplication(appId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                environment.gateway + 'application/' + appId, 'application/json', 'sp_id=' + this.authService.getSalesPersonId()).subscribe(
                    (data: any) => {
                        if (data.object) {
                            this.defaultLeaseeAddress = {
                                streetAddress: data.object.lessee.address,
                                city: data.object.lessee.city,
                                county: data.object.lessee.county,
                                state: data.object.lessee.state,
                                unit: data.object.lessee.unit,
                                zipCode: data.object.lessee.zipCode
                            };
                        }
                        resolve(data);
                    },
                    (error: any) => {
                        resolve(error);
                    }
                );
        });
    }

    onSubmitInvoiceDialog() {
        this.invoiceAddressFormSubmitted = true;
        if (this.invoiceAddressForm.invalid) {
            return;
        }

        this.validateQuantity().then(
            (data: any) => {
                this.numberOfDocsExceeded = data.object.numberOfDocsExceeded;
                if (data.object.attemptNumber < 1) {
                    this.openSelectOffersDialogAfterQuantityValidation();
                } else if (data.object.attemptNumber > 0) {
                    $('#summarySendDocsAddress' + this.appId).modal('hide');
                    this.numberOfAttempts = data.object.attemptNumber;
                    $('#attempModal' + this.appId).modal({ backdrop: 'static', keyboard: false });
                }
            },
            (error: any) => {
                this.messageTitle = 'Sorry, we found a problem';
                this.messageMessageA = 'Unfortunately we are unable to process your request at this moment.';
                this.messageMessageB = error.error.msg;
                this.messageMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                this.messageMessageBClass = 'mB20';
                this.dialogClass = 'w600';
                $('#summarySendDocsAddress' + this.appId).modal('hide');
                $('#errorModalDialog' + this.modalIdE).modal();
            }
        );
    }

    validateQuantity() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                environment.gateway + 'validateQuantity/' + this.appId, 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }

    openSelectOffersDialogAfterQuantityValidation() {
        this.multipleAddressValidation().then(
            (addressData: any) => {
                this.sendDocsToCustomer(Number(this.defaultOfferId));
            },
            (addressError: any) => {
                this.messageTitle = 'Sorry, we found a problem';
                this.messageMessageA = 'Unfortunately we are unable to process your request at this moment.';
                this.messageMessageB = addressError.error.msg;
                this.messageMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                this.messageMessageBClass = 'mB20';
                this.dialogClass = 'w600';
                $('#summarySendDocsAddress' + this.appId).modal('hide');
                $('#errorModalDialog' + this.modalIdE).modal();
            }
        );
    }

    multipleAddressValidation() {
        return new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'multipleaddressvalidation/', this.getInvoiceAddress(), 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }

    sendDocsToCustomer(selectedOffer: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.postRequest(
                environment.gateway + 'equipment/' + this.appId + '/' + this.authService.getUserId(),
                this.getInvoiceData(selectedOffer), 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                        $('#summarySendDocsAddress' + this.appId).modal('hide');
                        $('#sendContractsSuccess' + this.appId).modal();
                    },
                    (error: any) => {
                        this.messageTitle = 'Sorry, we found a problem';
                        this.messageMessageA = 'Unfortunately we are unable to process your request at this moment.';
                        this.messageMessageB = error.msg;
                        this.messageMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                        this.messageMessageBClass = 'mB20';
                        this.dialogClass = 'w600';
                        $('#summarySendDocsAddress' + this.appId).modal('hide');
                        $('#errorModalDialog' + this.modalIdE).modal();
                        reject(error);
                    }
                );
        });
    }

    onCloseModal() {
        this.reloadSlice.emit();
        this.ngOnInit();
    }

    requestedAmount(control: FormControl) {
        if (control.errors && !control.errors.requestedAmount) {
            return;
        }

        if (control.value < 500) {
            control.setErrors({ requestedAmount: true });
        } else {
            control.setErrors(null);
        }
        return new Promise((resolve, reject) => {
            void (0);
        });
    }

}
